module.exports = __webpack_public_path__ + "img/yybdsh@3x.eda9a28b.png";